/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Policy api models
  Date: April 2020
**/
import { action, thunk } from 'easy-peasy';

import { PolicyAPI } from '../../features/Policy/api';
import * as policyService from '../../services/policy';

const policyModel = {
  getDataFromPreSignedURL: thunk(async (actions, payload) => {
    return await policyService.getDataFromPreSignedURL(payload);
  }),

  getPolicyContent: thunk(async (actions, payload) => {
    return await policyService.getPolicyContent(payload);
  }),
  isPolicyLoaded: false,
  policyPK: '',
  policySK: '',

  searchPolicies: thunk(async (actions, payload) => {
    return PolicyAPI.search(payload);
  }),
  setPolicyPK: action((state, payload) => {
    state.policyPK = payload;
  }),
};

export default policyModel;
